const getMoonPhase = () => {
    const now = new Date();
    let year = now.getUTCFullYear();
    let month = now.getUTCMonth() + 1;
    const day = now.getUTCDate();

    let c = 0;
    let e = 0;
    let jd = 0;
    let b = 0;

    let phase = '';
    let index = 1;

    if (month < 3) {
        year--;
        month += 12;
    }

    ++month;

    c = 365.25 * year;
    e = 30.6 * month;
    jd = c + e + day - 694039.09; // Julian date calculation
    jd /= 29.53; // Divide by the moon's synodic period to get phase
    b = parseInt(jd); // Integer value of jd
    jd -= b; // Fractional value of jd
    b = Math.round(jd * 8); // Multiply by 8 to get phase value (0-7)
    if (b >= 8) {
        b = 0; // 0 and 8 are the same so set to new moon
    }

    switch (b) {
        case 0:
            phase = 'Nieuwe maan';
            index = 1;
            break;
        case 1:
            phase = 'Wassende maan';
            index = 2;
            break;
        case 2:
            phase = 'Eerste kwartier maan';
            index = 3;
            break;
        case 3:
            phase = 'Springende maan';
            index = 4;
            break;
        case 4:
            phase = 'Volle maan';
            index = 5;
            break;
        case 5:
            phase = 'Afnemende maan';
            index = 6;
            break;
        case 6:
            phase = 'Laatste kwartier maan';
            index = 7;
            break;
        case 7:
            phase = 'Asgrauwe maan';
            index = 8;
            break;
    }

    return {
        name: phase,
        index: index,
        date: now.toLocaleString('nl-NL', {
            month: 'long',
            day: 'numeric',
        }),
    };
};

const showMoonPhase = () => {
    const container = document.querySelector('.moonphase-lint');
    if (!container) {
        return;
    }

    const phase = getMoonPhase();
    const date = container.querySelector('.moonphase-lint-date');
    const text = container.querySelector('.moonphase-lint-name');
    const icon = container.querySelector(`.moonphase-lint-svg--phase-${phase.index}`);

    if (date) {
        date.innerHTML = phase.date;
    }

    if (text) {
        text.innerHTML = phase.name;
    }

    if (icon) {
        icon.classList.add('is-active');
    }
};

export default () => {
    showMoonPhase();
};
